import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LibAuthService, LibMessageService } from 'ngx-mat-base-comp';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  isDisabled = false;

  constructor(
    public authService: LibAuthService,
    private router: Router,
    private messageService: LibMessageService
  ) { }

  ngOnInit(): void {
    if (this.authService.isUnauthorizedUser) {
      this.messageService.showUnauthorizedErrorMessage();
    }
  }

  login(): void {
    this.isDisabled = true;
    this.router.navigate(['/core']);
  }

}
